import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-slate-300 p-4 md:p-8 font-sans relative overflow-hidden">

            {/* Effetti di sfondo decorativi */}
            <div className="fixed top-[-10%] left-[-10%] w-96 h-96 bg-sky-500/10 rounded-full blur-3xl pointer-events-none z-0"></div>
            <div className="fixed bottom-[-10%] right-[-10%] w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none z-0"></div>

            <div className="max-w-4xl mx-auto relative z-10">

                {/* Header Page */}
                <div className="flex items-center justify-between mb-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 text-slate-400 hover:text-sky-400 transition-colors duration-300 bg-slate-800/50 px-4 py-2 rounded-lg border border-slate-700/50 hover:bg-slate-800"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        Indietro
                    </button>
                    <div className="text-right">
                        <Link to="/" className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-emerald-400 tracking-tight">
                            QrFlow
                        </Link>
                    </div>
                </div>

                {/* Content Box */}
                <div className="bg-slate-800/60 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-6 md:p-10 shadow-2xl">
                    <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-2">Informativa sulla Privacy</h1>
                    <p className="text-sm text-slate-400 mb-8 border-b border-slate-700/50 pb-4">Ultimo aggiornamento: Ottobre 2023</p>

                    <div className="space-y-8 text-slate-300 leading-relaxed">

                        {/* Sezione 1: Titolare */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" /></svg>
                                1. Titolare del Trattamento
                            </h2>
                            <div className="bg-slate-900/50 rounded-xl p-5 border border-slate-700/50">
                                <p>Il Titolare del trattamento dei dati personali è:</p>
                                <ul className="mt-2 space-y-1 font-medium text-slate-200">
                                    <li><span className="text-slate-400">Nome:</span> Fatima Boukhama (operante come AxiomGroup)</li>
                                    <li><span className="text-slate-400">P.IVA:</span> 04717560983</li>
                                    <li><span className="text-slate-400">Sede Legale:</span> Via Fabio Filzi 37, Brescia (BS), Italia</li>
                                    <li><span className="text-slate-400">Email di contatto:</span> <a href="mailto:sviluppo@axiomgroup.it" className="text-sky-400 hover:underline">sviluppo@axiomgroup.it</a></li>
                                </ul>
                            </div>
                        </section>

                        {/* Sezione 2: Dati raccolti */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" /><path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" /></svg>
                                2. Quali dati raccogliamo
                            </h2>
                            <p className="mb-3">Attraverso l'utilizzo della piattaforma <strong>QrFlow</strong>, raccogliamo e trattiamo le seguenti categorie di dati:</p>
                            <ul className="list-disc list-inside space-y-2 ml-2">
                                <li><strong>Dati di Account:</strong> Indirizzo email, password (salvata in formato crittografato) e ruolo assegnato all'interno del sistema (es. Admin, Cliente).</li>
                                <li><strong>Dati di Utilizzo:</strong> Informazioni relative ai QR Code generati, gruppi creati, statistiche e log di scansione (data, ora, dispositivo utilizzato per la scansione).</li>
                                <li><strong>Dati Tecnici e Cookie:</strong> Indirizzo IP, tipo di browser e cookie tecnici strettamente necessari per mantenere attiva la sessione di login. <em>Non utilizziamo cookie di profilazione per scopi pubblicitari.</em></li>
                            </ul>
                        </section>

                        {/* Sezione 3: Finalità */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                3. Finalità del Trattamento
                            </h2>
                            <p>I tuoi dati vengono trattati esclusivamente per le seguenti finalità:</p>
                            <ul className="list-disc list-inside space-y-2 ml-2 mt-3">
                                <li>Consentire la registrazione, l'autenticazione e l'accesso sicuro al sistema QrFlow.</li>
                                <li>Erogare i servizi richiesti (creazione, gestione e tracciamento dei QR Code).</li>
                                <li>Fornire assistenza tecnica e rispondere alle comunicazioni inviateci.</li>
                                <li>Adempiere a eventuali obblighi di legge, contabili e fiscali.</li>
                            </ul>
                        </section>

                        {/* Sezione 4: Conservazione */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" /></svg>
                                4. Modalità e Tempi di Conservazione
                            </h2>
                            <p>
                                I dati sono trattati con strumenti informatici adottando misure di sicurezza adeguate a prevenire la perdita dei dati, usi illeciti o accessi non autorizzati.<br/>
                                <strong>Periodo di conservazione:</strong> I dati dell'account e di utilizzo verranno conservati per tutto il tempo in cui l'account rimarrà attivo. In caso di richiesta di cancellazione dell'account, i dati verranno eliminati in modo definitivo entro 30 giorni, fatti salvi eventuali dati di fatturazione che per legge devono essere conservati per 10 anni.
                            </p>
                        </section>

                        {/* Sezione 5: Diritti */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                5. I Tuoi Diritti (GDPR)
                            </h2>
                            <p>Ai sensi del Regolamento UE 2016/679 (GDPR), in qualità di interessato, hai il diritto di:</p>
                            <ul className="list-disc list-inside space-y-2 ml-2 mt-3 mb-4">
                                <li>Ottenere la conferma dell'esistenza o meno di tuoi dati personali e richiederne l'accesso.</li>
                                <li>Richiedere la rettifica o la cancellazione degli stessi (Diritto all'oblio).</li>
                                <li>Opporti al trattamento o richiederne la limitazione.</li>
                                <li>Richiedere la portabilità dei dati.</li>
                            </ul>
                            <p>
                                Per esercitare i tuoi diritti, puoi contattare il Titolare in qualsiasi momento inviando una email a: <br/>
                                <a href="mailto:sviluppo@axiomgroup.it" className="text-emerald-400 font-semibold hover:text-emerald-300 transition-colors">sviluppo@axiomgroup.it</a>
                            </p>
                        </section>

                    </div>
                </div>

                {/* Footer AxiomGroup */}
                <div className="mt-8 text-center pb-8">
                    <p className="text-sm text-slate-500 font-medium tracking-wide">
                        &copy; {new Date().getFullYear()} QrFlow. Gestito da{' '}
                        <a
                            href="https://axiomgroup.it"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sky-500 hover:text-sky-400 transition-colors duration-300 hover:underline decoration-sky-500/50 underline-offset-4"
                        >
                            AxiomGroup
                        </a>
                    </p>
                </div>

            </div>
        </div>
    );
};

export default PrivacyPolicyPage;